exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=text][data-v-aa1cc346],input[type=url][data-v-aa1cc346],select[data-v-aa1cc346],textarea[data-v-aa1cc346]{border:1px solid rgba(25,35,58,.3)!important;font-size:12px;padding:8px}", ""]);

// exports
